﻿import { Grid, Paper } from '@mui/material';
import { FC, useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUITabs } from '../../../../atomic/atoms';
import { AccountStatus } from '../AccountStatus/AccountStatus';
import { AccountHistory } from '../AccountHistory/AccountHistory';
import { ScrPaper } from '../ScrPaper/ScrPaper';
import { UserAccountFollowPaper } from '../UserAccountFollowPaper/UserAccountFollowPaper';
import { CommunicationPreference } from '../CommunicationPreference/CommunicationPreference';
import { useLocation } from 'react-router';
import { RptHistoryComponent } from '../RptHistoryComponent/RptHistoryComponent';
import { LinkedAccountsComponent } from '../LinkedAccountsComponent/LinkedAccountsComponent';
import { CommunicationPreferenceV2 } from '../CommunicationPreference/CommunicationPreferenceV2';
import { CUMP } from './customerUnderMenuPaper.classes';

interface IProps {
    datas?: any;
    refresh?: any;
    index?: any;
    tabDataVisibilityStatus: any;
}

export const CustomerUnderMenuPaper: FC<IProps> = ({ datas, refresh, index, tabDataVisibilityStatus }) => {
    const [tabIndex, setTabIndex] = useState<any>();
    const search = useLocation().search;
    const searchParams = new URLSearchParams(search);
    const _onChangeTabs = (event: any, activeTabIndex: any): void => {
        setTabIndex(activeTabIndex);
    };
    useEffect(() => {
        if (searchParams.get('ActiveTab') == 'CustomerInformation') {
            setTabIndex(index);
        }
    }, []);
    const { t } = useTranslation();
    return (
        <Paper className={CUMP.page} style={{ height: '50rem' }}>
            <Grid className={CUMP.tabsHost}>
                <SCUITabs
                    tabList={[
                        ...(datas.customer?.backofficeCustomerAccountHistoryShowStatusTemplate
                            ? [{ id: 10, name: t('customerInformation.accountHistory') }]
                            : []),
                        { id: 1, name: t('customerInformation.accountStatus') },
                        { id: 2, name: t('customerInformation.scr') },
                        tabDataVisibilityStatus.communicationPreferenceV2 === false && {
                            id: 3,
                            name: t('customerInformation.communicationPreferces'),
                        },
                        tabDataVisibilityStatus.communicationPreferenceV2 === true && {
                            id: 4,
                            name: t('customerInformation.communicationPreferces'),
                        },
                        { id: 7, name: t('customerInformation.customerFollows') },
                        tabDataVisibilityStatus.showRptHistory && { id: 8, name: t('customerInformation.rptHistory') },
                        tabDataVisibilityStatus.showLinkedAccounts && {
                            id: 9,
                            name: t('customerInformation.linkedAccount'),
                        },
                    ].filter(Boolean)}
                    onChange={_onChangeTabs}
                    activeTabIndex={tabIndex}
                    indicatorColor="red"
                />

                {tabIndex === 1 && (
                    <Grid
                        className={CUMP.panelAccountStatus}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <AccountStatus datas={datas} refresh={refresh} />
                    </Grid>
                )}
                {tabIndex === 2 && (
                    <Grid
                        className={CUMP.panelScr}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {' '}
                        <ScrPaper datas={datas} />
                    </Grid>
                )}
                {tabIndex === 3 && tabDataVisibilityStatus.communicationPreferenceV2 === false && (
                    <Grid
                        className={CUMP.panelCommunicationLegacy}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {' '}
                        <CommunicationPreference datas={datas} />
                    </Grid>
                )}
                {tabIndex === 4 && tabDataVisibilityStatus.communicationPreferenceV2 === true && (
                    <Grid
                        className={CUMP.panelCommunicationV2}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {' '}
                        <CommunicationPreferenceV2 datas={datas} />
                    </Grid>
                )}
                {tabIndex === 7 && (
                    <Grid
                        className={CUMP.panelFollows}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {' '}
                        <UserAccountFollowPaper datas={datas} />
                    </Grid>
                )}
                {tabDataVisibilityStatus.showRptHistory && tabIndex === 8 && (
                    <Grid
                        className={CUMP.panelRptHistory}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <RptHistoryComponent datas={datas} />
                    </Grid>
                )}
                {tabDataVisibilityStatus.showLinkedAccounts && tabIndex === 9 && (
                    <Grid
                        className={CUMP.panelLinkedAccounts}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <LinkedAccountsComponent datas={datas} />
                    </Grid>
                )}
                {tabIndex === 10 && (
                    <Grid
                        className={CUMP.panelAccountHistory}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <AccountHistory datas={datas} />
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
};

